<template>
   <el-header class="indexBox">
      <div class="search-box">
         <div class="search-b clearfix">
            <el-radio-group v-model="radioDatabase" @change="radioDatabaseFun">
               <template v-for="(item, index) in radioDatabaseAll">
                  <el-radio								
                  :key="index"
                  :label="item.code" :disabled="item.code=='innerdata'"
                  >{{ item.database }}</el-radio>
               </template>
            </el-radio-group>
         </div>
         <div class="search-t clearfix">
            <el-input
               placeholder="请输入检索内容"
               v-model="inputTxt"
               class="input-with-select fl"
               ref="ipt"
               @keyup.enter.native="searchFun"
            >
               <el-select
                  v-model="selectTxt"
                  slot="prepend"
                  placeholder="请选择"
               >
                  <el-option v-for="(item,index) in selectData" :key="index" :label="item.brief" :value="item.code"></el-option>
               </el-select>
               <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click.native="searchFun"
               ></el-button>
            </el-input>
            <!-- <el-input
               v-model="input"
               placeholder="请输入内容"
               class="fl ipt"
               @keyup.enter.native="search"
               ref="ipt"
            ></el-input>-->
            <!-- <el-button
               class="fr btn"
               type="primary"
               @click="resetFun"
               >重置</el-button
            > -->
         </div>
      </div>
   </el-header>
</template>
<script>
export default {
   props:['data'],
   data(){
        return{
           //检索框====
            inputTxt:"", //input输入的值
            radioDatabase: "", //不同的数据库
            radioDatabaseAll: [],//数据库-横向

            selectTxt: "", //下拉列表的值 默认选中主题
            selectData:[],//检索栏目-下拉框中的值
        }
    },
    created() {
		this.getDatabaseFun();//获取检索数据库数据	
      this.getSelectDataFun();//获取检索栏目数据
	},
	methods: {
		//切换数据库
		radioDatabaseFun(val){
			console.log(val);
		},
		//获取检索数据库数据
		getDatabaseFun(){
			this.axios
			.get(
				"/japi/knowledge/get_kbase_horizon/"
			)
			.then(res => {
				console.log("检索数据库数据======");
				console.log(res);
				if (res.data.code == 200) { 
					this.radioDatabaseAll=res.data.data;
					this.radioDatabase=res.data.data[0].code;
				} else {
					this.$message({
						message: res.data.msg,
						type: "warning",
						duration: 3000
					});
				}
			});
		},
		//获取检索栏目数据
		getSelectDataFun(){
			this.axios
			.get(
				"/japi/knowledge/get_select_column/"
			)
			.then(res => {
				console.log("检索栏目数据======");
				console.log(res);
				if (res.data.code == 200) { 
               this.selectData=res.data.data;
               this.selectTxt="theme";
				} else {
					this.$message({
						message: res.data.msg,
						type: "warning",
						duration: 3000
					});
				}
			});
      },
      //点击检索按钮 typeId:0 立法业务知识 1：立法领域知识
		searchFun() {	         
         this.inputTxt = this.inputTxt.trim();
         if(this.data=='index'){
            this.$router.push({path:'/legislateKnowledgeBase',query:{radioDatabase:this.radioDatabase,inputTxt:this.inputTxt,selectTxt:this.selectTxt}});
         }
         // if (this.inputTxt) {
         //    if(this.data=='index'){
         //       this.$router.push({path:'/legislateKnowledgeBase',query:{radioDatabase:this.radioDatabase,inputTxt:this.inputTxt,selectTxt:this.selectTxt}});
         //    }
         // } else {
         //    this.$message({
         //       message: "请输入检索内容",
         //       type: "warning",
         //       duration: 1000,
         //    });
         //    //input获取焦点
         //    this.$nextTick(() => {
         //       this.$refs.ipt.focus();
         //    });
         // }         		
		},      
	},
}
</script>
<style lang="scss" scoped> 
@import "../../assets/css/mixin.scss"; //定义方法
@import "../../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
</style>